export class Sfx {
  private ctx: AudioContext | null = null;

  private ensure(): AudioContext | null {
    if (!this.ctx) {
      try {
        this.ctx = new AudioContext();
      } catch {
        return null;
      }
    }
    if (this.ctx.state === "suspended") void this.ctx.resume();
    return this.ctx;
  }

  private tone(freq: number, dur: number, type: OscillatorType, vol: number, slideTo?: number, delay = 0): void {
    const ctx = this.ensure();
    if (!ctx) return;
    const t0 = ctx.currentTime + delay;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, t0);
    if (slideTo !== undefined) osc.frequency.exponentialRampToValueAtTime(Math.max(1, slideTo), t0 + dur);
    gain.gain.setValueAtTime(vol, t0);
    gain.gain.exponentialRampToValueAtTime(0.001, t0 + dur);
    osc.connect(gain).connect(ctx.destination);
    osc.start(t0);
    osc.stop(t0 + dur + 0.02);
  }

  resume(): void {
    this.ensure();
  }

  jump(): void {
    this.tone(300, 0.25, "square", 0.12, 900);
  }
  coin(): void {
    this.tone(988, 0.08, "square", 0.1);
    this.tone(1319, 0.3, "square", 0.1, undefined, 0.08);
  }
  stomp(): void {
    this.tone(400, 0.12, "triangle", 0.2, 120);
  }
  bump(): void {
    this.tone(120, 0.08, "square", 0.15);
  }
  brk(): void {
    this.tone(220, 0.15, "sawtooth", 0.15, 60);
  }
  kick(): void {
    this.tone(500, 0.1, "square", 0.12, 900);
  }
  powerup(): void {
    const notes = [523, 659, 784, 1047, 1319, 1568];
    notes.forEach((n, i) => this.tone(n, 0.09, "square", 0.09, undefined, i * 0.06));
  }
  powerdown(): void {
    this.tone(600, 0.4, "square", 0.1, 150);
  }
  die(): void {
    const notes = [494, 466, 440, 415, 392, 349, 294];
    notes.forEach((n, i) => this.tone(n, 0.12, "square", 0.1, undefined, i * 0.09));
  }
  win(): void {
    const notes = [392, 523, 659, 784, 1047, 784, 1047];
    notes.forEach((n, i) => this.tone(n, 0.14, "square", 0.09, undefined, i * 0.11));
  }
  pipe(): void {
    // descending whistle sound
    this.tone(600, 0.35, "sine", 0.15, 100);
  }
}
